import { useEffect, useState } from 'react';

import axios from 'axios';
import type { AxiosResponse } from 'axios';

import type { IAccount } from '@admin/types/account';

import { useAxiosRequest } from './use_axios_request';

export const useAccountRequest = (accountID: number | string) => {
  const [request, setRequest] = useState<Promise<AxiosResponse<IAccount>> | undefined>();

  useEffect(() => {
    setRequest(axios.get<IAccount>(`/accounts/${accountID}.json`));
  }, [accountID]);

  return useAxiosRequest(request);
};
